import React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import type { ProductPriceAndRatingProps } from './ProductPriceAndRating';
import { ProductPriceAndRating } from './ProductPriceAndRating';

export const ProductPriceAndRatingWithTracking = (props: ProductPriceAndRatingProps) => {
  const handleReviewsLinkClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    sendGALinkClickEvent(evt, {
      event: 'custom_event',
      event_action: 'Read reviews click',
      event_category: 'Product reviews',
      event_label: 'not set',
    });
  };

  return <ProductPriceAndRating {...props} onReviewsLinkClick={handleReviewsLinkClick} />;
};
